define('modules/loading/loading_spinner_view',[
  'backbone',
  'jquery',
  '_',
  'modules/animation/transition-end'
], function (Backbone, $, _,
             transitionEnd) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (attachTo, append) {
      this.render();

      this.attachTo = attachTo ? attachTo : $('.js-page-content');
      this.attachTo[append ? 'append' : 'prepend'](this.$el);
    },

    tagName: 'span',
    className: 'loading-spinner',

    render: function () {
      this.$el.html();
      return this;
    },

    start: function () {
      this.$el.show().addClass('is-loading');
      return this;
    },

    done: function () {
      this.$el.hide();
      return this;
    },

    remove: function () {
      this.$el.remove();
      this.stopListening();
      return this;
    }
  });
  return View;
});

